import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Crown } from "lucide-react";

export default function Nav() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    if (loc.pathname.startsWith("/u/") || loc.pathname === "/auth-callback") return null;

    return (
        <nav className="fixed top-0 left-0 right-0 z-40 glass border-b border-white/5 transition-all duration-300">
            <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
                    <img
                        src="/connexa-logo.png"
                        alt="Connexa"
                        className="h-28 md:h-32 w-auto object-contain drop-shadow-[0_0_24px_rgba(16,185,129,0.35)]"
                        style={{ imageRendering: "auto" }}
                    />
                </Link>

                <div className="hidden md:flex items-center gap-8">
                    <Link to="/" className="text-sm font-medium text-gray-400 hover:text-brand-400 transition-colors" data-testid="nav-home">Home</Link>
                    {user && (
                        <Link to="/dashboard" className="text-sm font-medium text-gray-400 hover:text-brand-400 transition-colors" data-testid="nav-dashboard">Dashboard</Link>
                    )}
                    {user?.role === "admin" && (
                        <Link to="/admin" className="text-sm font-medium text-yellow-400 hover:text-yellow-300 transition-colors flex items-center gap-1" data-testid="nav-admin">
                            <Crown className="w-3.5 h-3.5" /> Admin
                        </Link>
                    )}
                    <Link to="/pricing" className="text-sm font-medium text-gray-400 hover:text-brand-400 transition-colors" data-testid="nav-pricing">Pricing</Link>
                </div>

                <div className="flex items-center gap-4">
                    {user ? (
                        <>
                            <Link to="/qr" className="btn-primary px-6 py-2.5 rounded-full text-sm font-semibold text-white" data-testid="nav-my-qr">My QR</Link>
                            <button
                                onClick={async () => { await logout(); nav("/"); }}
                                className="text-sm font-medium text-gray-400 hover:text-red-400 transition-colors flex items-center gap-1"
                                data-testid="nav-logout"
                            >
                                <LogOut className="w-4 h-4" /> Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-testid="nav-login">Login</Link>
                            <Link to="/register" className="btn-primary px-6 py-2.5 rounded-full text-sm font-semibold text-white" data-testid="nav-register">Get Started</Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
}
